import React from 'react';
import cx from 'classnames';
import { Button, ButtonVariant } from '@vimily/bonjoro-ui-components-v2/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faSearch } from '@fortawesome/free-solid-svg-icons';
import TagsDropdown from '../../../../Components/TagsDropdown';
import { usePublishSelectModalContext } from '~/App/Modules/Testimonials/Pages/Publish/Editor/Contexts/PublishSelectModalContext';
import { ModalTabs } from '~/App/Modules/Testimonials/Pages/Publish/Editor/Containers/PublishModal/types';
import { useDebouncedCallback } from 'beautiful-react-hooks';
import { MAX_TESTIMONIALS } from '../../../../../constants';
import { usePublishEditorState } from '../../../../Contexts/PublishEditorContext';
import { PublishableType } from '~/types/models/publishable';

export interface SelectControllerProps {
  selectedTab: ModalTabs;
}
export default function SelectController({
  selectedTab = ModalTabs.All,
}: SelectControllerProps) {
  const publishSelectModalContext = usePublishSelectModalContext();
  const [{ type }] = usePublishEditorState();

  if (!publishSelectModalContext) {
    return <></>;
  }

  const {
    selectAllIds,
    removeAllSelectedIds,
    setModalSearchString,
    modalSearchString,
    updateSelectedAllIdsForKey,
    selectedAllIds,
    selectedIds,
  } = publishSelectModalContext;

  const handleSelectAll = () => {
    selectAllIds(ModalTabs[selectedTab] as ModalTabs);
    updateSelectedAllIdsForKey(ModalTabs[selectedTab] as ModalTabs, true);
  };

  const handleDeselectAll = () => {
    removeAllSelectedIds(ModalTabs[selectedTab] as ModalTabs);
    updateSelectedAllIdsForKey(ModalTabs[selectedTab] as ModalTabs, false);
  };

  const handleSearch = useDebouncedCallback(
    (searchQuery: string) => {
      setModalSearchString(searchQuery);
    },
    [setModalSearchString],
    500
  );

  const hideSelectAll =
    selectedAllIds[selectedTab] ||
    (selectedIds.length >= MAX_TESTIMONIALS && type === PublishableType.Slider);

  return (
    <div className='bg-neutral-50 h-[60px] py-[10px] px-[20px] flex items-center justify-between'>
      <div className='flex items-center'>
        <div className='border-r-2 border-l-0 border-y-0 border-solid v2-border-neutral-100 pl-0 pr-[15px] mr-[15px] w-[140px] flex'>
          <Button
            variant={ButtonVariant.Secondary}
            size='md'
            className={cx('v2-bg-transparent !px-[10px]', {
              hidden: hideSelectAll,
            })}
            bgColorClassName='v2-bg-transparent'
            onClick={handleSelectAll}
          >
            <div className='w-[95px]'>Select all</div>
          </Button>
          <Button
            variant={ButtonVariant.Secondary}
            size='md'
            className={cx('v2-bg-transparent !px-[10px]', {
              hidden: !hideSelectAll,
            })}
            bgColorClassName='v2-bg-transparent'
            onClick={handleDeselectAll}
          >
            <div className='w-[95px]'>Deselect all</div>
          </Button>
        </div>
        <div className='mr-[33px]'>
          <FontAwesomeIcon
            icon={faFilter}
            className='mr-[8px] v2-text-[20px]'
          />
          <span className='v2-text-[16px] font-bold'>Filter by</span>
        </div>
        <div className='z-20'>
          <TagsDropdown />
        </div>
      </div>
      {selectedTab !== ModalTabs.Social && (
        <div className='relative w-64'>
          <input
            type='text'
            placeholder='Search'
            defaultValue={modalSearchString}
            onChange={(e) => handleSearch(e.target.value)}
            className='w-full py-2 pr-10 pl-3 border v2-border-neutral-300 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:border-transparent  hover:outline-none hover:ring-2  hover:ring-yellow-500  hover:border-transparent  '
          />
          <div className='absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none'>
            <FontAwesomeIcon
              icon={faSearch}
              className='v2-text-neutral-500 v2-text-[20px]'
            />
          </div>
        </div>
      )}
    </div>
  );
}
